import React from 'react';

const DeleteMyOrder = ({ reload, setIsReload, deleteProduct }) => {

    const { _id } = deleteProduct;
    console.log(_id)

    const handleItemDelete = id => {
        const url = `https://young-everglades-39818.herokuapp.com/myorders/${id}`;
        fetch(url, {
            method: 'DELETE'
        })
            .then(res => res.json())
            .then(data => {
                setIsReload(!reload)
            })

    }


    return (
        <div>
            <input type="checkbox" id="my-modal-3" class="modal-toggle" />
            <div class="modal modal-bottom sm:modal-middle">
                <div class="modal-box">
                    <h3 class="font-bold text-lg">Are you sure about deleting this product?</h3>
                    <p class="py-4">Deletion is permanent, you can't go reverse once the item is deleted. Select confirm to delete, or cancel the operation!!!</p>
                    <div class="modal-action">
                        <label for="my-modal-3" class="btn" onClick={() => handleItemDelete(_id)}>Confirm</label>
                        <label for="my-modal-3" class="btn">Cancel</label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteMyOrder;